import { useEffect } from 'react';

import { mainApi } from 'utils/api';
import { checkVisitorSession, setVisitorSession } from 'utils/jwtUtil';

import HeroSection from './HeroSection';
import Clients from './Clients';
import VideoWhyBriphy from './WhyBriphy';
import Portfolio from './Portfolio';
import Process from './Process';
import Review from './Review';
import Contact from './Contact';
import NaverADLogAnalysticsChange from 'components/NaverADLogAnalyticsConvert';

const VideoLanding = () => {
  
  // 초기 화면 접속 시 접속 이력 저장
  useEffect(() => {
    if (!checkVisitorSession('mainVisit')) {
      mainApi.insertConnectInfo({pageDvnm: '영상메인'});
      setVisitorSession('mainVisit');
    } 
  }, []);

  return (
    <>
      {/* <script
        dangerouslySetInnerHTML={{
          __html: `
          var _nasa={};
          if(window.wcs) _nasa["cnv"] = wcs.cnv("5","0"); // 전환유형 : 기타로 설정

          if (!wcs_add) var wcs_add={};
          wcs_add["wa"] = "s_5030e6e28cbd";
          if (!_nasa) var _nasa={};
          if(window.wcs){
            wcs.inflow("briphy.com");
            wcs_do(_nasa);
          }
          `
        }}
      /> */}
      <NaverADLogAnalysticsChange type='5' value='0' isExcludeConvert={true} />
      <HeroSection />
      <Clients />
      <VideoWhyBriphy />
      <Portfolio />
      <Process />
      <Review />
      <Contact />
    </>
  )
}

export default VideoLanding;